import { AllQuestions } from "@abbvie-epi/common/models";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, firstValueFrom, map, Observable, of } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class QuestionsService {
    private questionsConfig: AllQuestions | undefined;

    constructor(private http: HttpClient) {
        this.http = http;
    }

    public getData() {
        return this.http.get("assets/config/questions-config.json");
    }

    public getQuestionsConfig(): Observable<AllQuestions | undefined> {
        if (this.questionsConfig) {
            return of(this.questionsConfig);
        }

        return this.http.get("assets/config/questions-config.json").pipe(
            map((res: any) => {
                return res as AllQuestions;
            }),
            catchError((e) => {
                console.log(e);
                return of(undefined);
            })
        );
    }

    public async getQuestionIdList(): Promise<string[]> {
        const questionConfig = await firstValueFrom(this.getQuestionsConfig());

        if (questionConfig) {
            return Object.keys(questionConfig);
        }

        return [];
    }
}
